// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1v6c_","validationTips":"StatementDescriptor_validationTips__2P-8X"};